/**
 * #js-post 内の見出しタグ内にある strong タグを外す
 *
 * 例:
 * <h2><strong>見出しテキスト</strong></h2>
 * ↓
 * <h2>見出しテキスト</h2>
 */
class VanillaUnwrapHeadingStrong {
  constructor(options = {}) {
    this.rootSelector = options.rootSelector || "#js-post";
    this.headingSelector = options.headingSelector || "h1, h2, h3, h4, h5, h6";

    this.root = null;
    this.headings = [];

    this.init();
  }

  init() {
    this.root = document.querySelector(this.rootSelector);

    if (!this.root) {
      return;
    }

    this.headings = [...this.root.querySelectorAll(this.headingSelector)];

    if (!this.headings.length) {
      return;
    }

    this.unwrapStrong();
  }

  unwrapStrong() {
    this.headings.forEach((heading) => {
      const strongs = [...heading.querySelectorAll("strong")];

      if (!strongs.length) {
        return;
      }

      strongs.forEach((strong) => {
        this.unwrapElement(strong);
      });
    });
  }

  unwrapElement(element) {
    const parent = element.parentNode;

    if (!parent) {
      return;
    }

    while (element.firstChild) {
      parent.insertBefore(element.firstChild, element);
    }

    parent.removeChild(element);
  }
}

export default VanillaUnwrapHeadingStrong;
